import { useState } from "react";
import { motion } from "framer-motion";
import { Share2 } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { MANIFESTO } from "@/data/site";
import { Reveal } from "@/components/Reveal";
import ManifestoStoryCard from "@/components/ManifestoStoryCard";

const EASE = [0.16, 1, 0.3, 1];

const Manifesto = () => {
  const { t, tr } = useLang();
  const [showStory, setShowStory] = useState(false);
  const chapter4 = MANIFESTO[3];

  return (
    <section className="bg-cream border-b border-ink py-20 md:py-28" data-testid="manifesto">
      <div className="max-w-[1440px] mx-auto px-4 md:px-8">
        <Reveal>
          <p className="kicker text-pink">{t.manifestoKicker}</p>
          <h2 className="display uppercase text-5xl md:text-8xl leading-[0.84] mt-3 max-w-5xl text-brand">
            {t.manifestoTitle}
          </h2>
        </Reveal>

        <div className="mt-14 md:mt-20">
          {MANIFESTO.map((c) => (
            <motion.div
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.7, ease: EASE }}
              className="grid md:grid-cols-12 gap-4 md:gap-8 py-10 md:py-14 border-t border-ink items-start group"
            >
              <div className="md:col-span-3">
                <span
                  className="display text-7xl md:text-8xl leading-none inline-block transition-transform duration-500 group-hover:translate-x-2"
                  style={{ color: c.color }}
                >
                  {c.n}
                </span>
              </div>
              <h3 className="md:col-span-5 display uppercase text-3xl md:text-4xl leading-[0.9]">{tr(c.title)}</h3>
              <p className="md:col-span-4 text-lg font-medium text-ink/70">{tr(c.body)}</p>
            </motion.div>
          ))}
          <div className="border-t border-ink" />
        </div>

        <Reveal className="mt-10 flex flex-col sm:flex-row items-start sm:items-center gap-4 justify-between">
          <p className="kicker text-ink/50">04 · {tr(chapter4.title)}</p>
          <button
            onClick={() => setShowStory(true)}
            data-testid="manifesto-share"
            className="btn-primary h-12 px-6 text-sm"
          >
            <Share2 className="w-4 h-4" strokeWidth={2} /> {t.manifestoShare}
          </button>
        </Reveal>
      </div>

      <ManifestoStoryCard
        open={showStory}
        onClose={() => setShowStory(false)}
        title={tr(chapter4.title)}
        body={tr(chapter4.body)}
      />
    </section>
  );
};

export default Manifesto;
